import { Controller } from "@hotwired/stimulus";

/**
 * GO4TEACH lot 20 — « Envoyer sur WhatsApp »: the sheet as plain-text messages (made by the server,
 * `Go4teach::WhatsappText`). The first one goes through the Web Share API when the browser has it
 * (the phone's share sheet, WhatsApp in it), else through the `https://wa.me/?text=` link the button
 * already carries; every message can be copied, to paste the next ones into the same chat.
 */
export default class extends Controller {
  static targets = ["message"];
  static values = { copied: String };

  async send(event) {
    if (!navigator.share) return; // the link opens wa.me
    event.preventDefault();
    try {
      await navigator.share({ text: this.messageTargets[0].value });
    } catch (_error) {
      // Closed without sharing.
    }
  }

  async copy(event) {
    const button = event.currentTarget;
    const text = this.messageTargets[parseInt(button.dataset.index, 10)].value;
    try {
      await navigator.clipboard.writeText(text);
    } catch (_error) {
      const field = this.messageTargets[parseInt(button.dataset.index, 10)];
      field.select();
      document.execCommand("copy");
    }
    const label = button.textContent;
    button.textContent = this.copiedValue;
    setTimeout(() => { button.textContent = label; }, 1500);
  }
}
